import React from "react";
import Container from "../../common/Container";
import { HeaderRow, HeaderSection, RegNumber } from "./styles";
import { HeaderProps } from "./types";

const Header: React.FC<HeaderProps> = () => {
	//const [visible, setVisibility] = useState(false);

	return (
		<HeaderSection>
			<Container>
				<HeaderRow>
					<RegNumber>VO/2637</RegNumber>
				</HeaderRow>
				{/* 				<Row justify="end">
					<NotHidden>
						<MenuItem />
					</NotHidden>
					<Burger onClick={toggleButton}>
						<Outline />
					</Burger>
				</Row>
				<Drawer closable={false} open={visible} onClose={toggleButton}>
					<Col style={{ marginBottom: "2.5rem" }}>
						<Label onClick={toggleButton}>
							<Col span={12}>
								<Menu>Menu</Menu>
							</Col>
							<Col span={12}>
								<Outline />
							</Col>
						</Label>
					</Col>
					<MenuItem />
				</Drawer> */}
			</Container>
		</HeaderSection>
	);
};

export default Header;
